import { useAppDispatch } from './hooks'
import { hydrate } from './slices/mediaSlice'
import { PropsWithChildren } from 'react'

function Hydrate({ children }: PropsWithChildren<{}>) {
    const dispatch = useAppDispatch()
    dispatch(hydrate())

    return <>{children}</>
}

export default Hydrate
